import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import {Button} from "../ui/button";

export default function CheckoutFooter({cookieAccepted, cookieHeight}) {
    const items = useSelector((state) => state.cart.items);
    const navigate = useNavigate();
    const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);
    const isDesktop = useMemo(() => {
        if (typeof window === 'undefined') return false;
        return window.matchMedia('(min-width: 1024px)').matches;
    }, []);
    const bottomOffset =
        isDesktop ? 0 : cookieAccepted ? 0 : cookieHeight || 0;
    const location = useLocation();

    // useEffect(() => {
    // }, [bottomOffset]);

    const hiddenRoutes = [
        '/cart',
        '/shipping',
        '/billing',
        '/orderconfirmation',
        '/terms-of-use',
        '/privacy-policy',
        '/shipping-policy',
        '/return-policy',
        '/contactus',
        '/about-us',
        '/faq',
    ];
    const hiddenRoutePrefixes = [
        '/blog',
    ];

    const shouldHide =
        hiddenRoutes.includes(location.pathname) ||
        hiddenRoutePrefixes.some(prefix =>
            location.pathname.startsWith(prefix)
        );

    if (shouldHide) return null;


    if (!items || items.length === 0) return null;

    return (
        <div
            className="
                fixed left-0 right-0
                lg:relative lg:bottom
                z-50
                bg-primary/95 text-text-headerfooter
                shadow-xl rounded-t-xl
                transition-all duration-300
            "
            style={{bottom: bottomOffset}}
        >
            <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
                <div className="flex flex-col">
                    <span className="text-sm font-medium">
                      {totalItems} item{totalItems > 1 ? 's' : ''}
                    </span>
                    <span className="text-xs opacity-80 leading-tight">
                      30-day return guarantee
                    </span>
                </div>

                <Button
                    onClick={() => navigate('/shipping')}
                    variant="solid"
                    className="shrink-0"
                >
                    Continue Checkout
                </Button>
            </div>
        </div>
    );
}
